(function ($) {
  Drupal.behaviors.pclsupport = {
    attach: function (context, settings) {
      var thisModule = $('.field-content');
      var thisMobileModule = $('.field-mobile-template');

      // Testing
      // thisModule.addClass('pcl_rtl');
      // thisMobileModule.addClass('pcl_rtl');

      // Check for rtl
      function checkDirRTL() {
        if ($('html').is("[dir]")) {
          var dir = $("html").attr("dir");
          if (dir === "rtl") {
            thisModule.addClass('pcl_rtl');
            thisMobileModule.addClass('pcl_rtl');
          }
        }
      }
      checkDirRTL();
    }
  };
})(jQuery);
